"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "crevacuore": {
    "c07714a6": [{
      "hkey": "e0edd7b3",
      "slug": "crevacuore",
      "name": "Crevacuore",
      "primary": true,
      "skipSearch": false
    }],
    "pianezza": [{
      "hkey": "e0edd7b3",
      "slug": "crevacuore",
      "name": "Crevacuore",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "672c6eb6": [{
      "hkey": "e0edd7b3",
      "slug": "crevacuore",
      "name": "Crevacuore",
      "primary": true,
      "skipSearch": false
    }],
    "san-defendente": [{
      "hkey": "e0edd7b3",
      "slug": "crevacuore",
      "name": "Crevacuore",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "4f853c66": [{
      "hkey": "e0edd7b3",
      "slug": "crevacuore",
      "name": "Crevacuore",
      "primary": true,
      "skipSearch": false
    }],
    "san-rocco": [{
      "hkey": "e0edd7b3",
      "slug": "crevacuore",
      "name": "Crevacuore",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;